import React from 'react';
import { Dialog, DialogActions, DialogContent, DialogTitle, IconButton } from '@mui/material';
import { IconX } from '@tabler/icons-react';
import { useStyles } from './styles';
import CompanyForm from './components/CreateCompanyForm';
import { useTranslation } from 'react-i18next';

interface CreateCompanyPopupProps {
  showDialogFlag: boolean;
  closeDialog: () => void;
}

export const CreateCompanyPopup: React.FC<CreateCompanyPopupProps> = ({
  showDialogFlag,
  closeDialog,
}) => {
  const { classes } = useStyles();
  const { t } = useTranslation();

  return (
    <Dialog
      open={showDialogFlag}
      onClose={closeDialog}
      aria-labelledby="form-dialog-title"
      aria-describedby="form-dialog-description"
      className={classes.dialog}>
      <DialogTitle id="form-dialog-title" className={classes.dialogTitle}>
        {t('superAdminMainPage.companies.operation.createCompany')}
        <IconButton className={classes.customizedButton} onClick={closeDialog} aria-label="close">
          <IconX size={20} />
        </IconButton>
      </DialogTitle>
      <DialogContent className={classes.dialogContent}>
        {showDialogFlag ? <CompanyForm closeDialog={closeDialog} /> : null}
      </DialogContent>
      <DialogActions>
        <IconButton className={classes.customizedButton} onClick={closeDialog} aria-label="close">
          <IconX size={20} />
        </IconButton>
      </DialogActions>
    </Dialog>
  );
};
